import { LabsModeSwitch } from "@/zapi-frontend/features/LabsModeSwitch";
import { CustomSnippetsUrlSection } from "./CustomSnippetsUrlSection";
import { UserSettings } from "./_UserSettings";

export function ProfileSection() {
  return (
    <div className="space-y-8">
      <UserSettings />
      <LabsModeSwitch showDescription={true} />
      <CustomSnippetsUrlSection />
    </div>
  );
}
